
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './components/App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

// https://github.com/hackingbeauty/jimjam-boilerplate


ReactDOM.render(
	<App />, document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx